import LoginVerificationMessage from './LoginVerificationMessage';

export default LoginVerificationMessage;
